import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

interface DeveloperPassword {
  password: string;
  createdAt: Date;
  updatedAt: Date;
}

export const developerService = {
  // Verificar se existe senha de desenvolvedor
  async hasPassword(): Promise<boolean> {
    try {
      const docRef = doc(db, 'system', 'developer_password');
      const docSnap = await getDoc(docRef);
      return docSnap.exists();
    } catch (error) {
      console.error('Erro ao verificar senha de desenvolvedor:', error);
      return false;
    }
  },

  // Criar/atualizar senha de desenvolvedor
  async setPassword(password: string): Promise<void> {
    try {
      const docRef = doc(db, 'system', 'developer_password');
      const passwordData: DeveloperPassword = {
        password: password,
        createdAt: new Date(),
        updatedAt: new Date()
      };
      
      await setDoc(docRef, passwordData);
    } catch (error) {
      console.error('Erro ao salvar senha de desenvolvedor:', error);
      throw error;
    }
  },

  // Verificar senha de desenvolvedor
  async verifyPassword(password: string): Promise<boolean> {
    try {
      const docRef = doc(db, 'system', 'developer_password');
      const docSnap = await getDoc(docRef);
      
      if (!docSnap.exists()) {
        return false;
      }
      
      const data = docSnap.data() as DeveloperPassword;
      return data.password === password;
    } catch (error) {
      console.error('Erro ao verificar senha de desenvolvedor:', error);
      return false;
    }
  }
};
